import React from "react";
import {
  MobilePaginationWrapper2,
  MobilePaginationList,
  MobilePaginationArrow,
  MobilePaginationInfo,
} from "../../styles/dashboard";
import Back from "../../assets/svgs/Pagination/back.svg";
import Next from "../../assets/svgs/Pagination/next.svg";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

type PaginationMobileProps = {
  onPageChange: (page: number) => void;
  totalPageCount: number;
  currentPage: number;
  pageSize?: number;
  className?: string;
};

const PaginationMobile: React.FC<PaginationMobileProps> = ({
  onPageChange,
  totalPageCount,
  currentPage,
  className,
  pageSize
}) => {
  // Always show pagination, even for single page
  if (totalPageCount === 1) {
    return (
      <MobilePaginationWrapper2 className={className}>
        <MobilePaginationList>
          {/* First Page Button - disabled for single page */}
          <MobilePaginationArrow 
            $disabled={true} 
            onClick={() => {}}
            title="First page"
          >
            <KeyboardDoubleArrowLeftIcon sx={{ color : "#FFF",fontSize: 24}}/>
          </MobilePaginationArrow>

          {/* Previous Arrow - disabled for single page */}
          <MobilePaginationArrow 
            $disabled={true} 
            onClick={() => {}}
            title="Previous page"
          >
            <img src={Back} alt="Previous" />
          </MobilePaginationArrow>

          {/* Current Page Info */}
          <MobilePaginationInfo>
            <span>1 of 1</span>
          </MobilePaginationInfo>

          {/* Next Arrow - disabled for single page */}
          <MobilePaginationArrow 
            $disabled={true} 
            onClick={() => {}}
            title="Next page"
          >
            <img src={Next} alt="Next" />
          </MobilePaginationArrow>

          {/* Last Page Button - disabled for single page */}
          <MobilePaginationArrow 
            $disabled={true} 
            onClick={() => {}}
            title="Last page"
          >
            <KeyboardDoubleArrowRightIcon sx={{ color : "#FFF",fontSize: 24}}/>
          </MobilePaginationArrow>
        </MobilePaginationList>
      </MobilePaginationWrapper2>
    );
  }

  // If there are no pages, don't render component
  if (totalPageCount <= 0) {
    return null;
  }

  const onNext = () => {
    if (currentPage < totalPageCount) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const onFirst = () => {
    if (currentPage > 1) {
      onPageChange(1);
    }
  };

  const onLast = () => {
    if (currentPage < totalPageCount) {
      onPageChange(totalPageCount);
    }
  };

  return (
    <MobilePaginationWrapper2 className={className}>
      <MobilePaginationList>
        {/* First Page Button */}
        <MobilePaginationArrow 
          $disabled={currentPage === 1} 
          onClick={onFirst}
          title="First page"
        >
          <KeyboardDoubleArrowLeftIcon sx={{ color : "#FFF",fontSize: 24}}/>
        </MobilePaginationArrow>

        {/* Previous Arrow */}
        <MobilePaginationArrow 
          $disabled={currentPage === 1} 
          onClick={onPrevious}
          title="Previous page"
        >
          <img src={Back} alt="Previous" />
        </MobilePaginationArrow>

        {/* Current Page Info */}
        <MobilePaginationInfo>
          <span>{currentPage} of {totalPageCount}</span>
        </MobilePaginationInfo>

        {/* Next Arrow */}
        <MobilePaginationArrow 
          $disabled={currentPage === totalPageCount} 
          onClick={onNext}
          title="Next page"
        >
          <img src={Next} alt="Next" />
        </MobilePaginationArrow>

        {/* Last Page Button */}
        <MobilePaginationArrow 
          $disabled={currentPage === totalPageCount} 
          onClick={onLast}
          title="Last page"
        >
          <KeyboardDoubleArrowRightIcon sx={{ color : "#FFF",fontSize: 24}}/>
        </MobilePaginationArrow>
      </MobilePaginationList>
    </MobilePaginationWrapper2>
  );
};

export default PaginationMobile;
